export default __webpack_public_path__ + "static/media/support-icon.918a81ef.svg";